import * as React from 'react';
import { RestrictionsTable } from '../clients/RestrictionsTable';
import { NewRestrictionModal } from '../clients/NewRestrictionModal';
import { useRestrictions } from '../../hooks/useRestrictions';
import { useAuth } from '../../core/context/ProvidersContext';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import styles from './ClientsView.module.scss';
import appStyles from '../App.module.scss';

export const ClientsView: React.FC = () => {
  const { restrictions, loading, error, refresh } = useRestrictions();
  const { hasRole } = useAuth();
  const isAdmin = hasRole('admin');

  const [creating, setCreating] = React.useState(false);

  if (loading) {
    return (
      <div className={appStyles.loading}>
        <Spinner size={SpinnerSize.medium} label="Chargement des restrictions..." />
      </div>
    );
  }

  if (error) {
    return <div className={appStyles.error}>{error}</div>;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.toolbar}>
        <div>
          <h2 className={styles.title}>Restrictions clients</h2>
          <p className={styles.subtitle}>
            {restrictions.length} restriction{restrictions.length > 1 ? 's' : ''} active{restrictions.length > 1 ? 's' : ''}
            {' '}sur les produits et dépôts
          </p>
        </div>
        {isAdmin && (
          <button className={styles.newBtn} onClick={() => setCreating(true)}>
            <span className={styles.newBtnIcon}>+</span>
            Nouvelle restriction
          </button>
        )}
      </div>

      <RestrictionsTable
        restrictions={restrictions}
        onDataChanged={refresh}
      />

      {creating && (
        <NewRestrictionModal
          onCreated={() => { setCreating(false); refresh(); }}
          onCancel={() => setCreating(false)}
        />
      )}
    </div>
  );
};
